/* Landing musa — JS extraido de Clon MiSuplemento - Creatina Mujeres/index.html.
   Cargado por layout/landing.liquid (case 'musa'). */

/* ---- Marquees: duplicar items para loop infinito ---- */
function fillMarquee(id, items){
  const el = document.getElementById(id);
  const html = items.map(t=>`<span>${t}</span>`).join('');
  el.innerHTML = html + html; /* duplicado = loop sin salto */
}
fillMarquee('marquee1', ['Pago contra entrega','Stock limitado ⚠️','Envío gratis 2-4 días','Garantía de 30 días']);
fillMarquee('marquee2', ['Fórmula femenina','Calidad premium','Viral en TikTok','Fórmula femenina','Calidad premium','Viral en TikTok']);
fillMarquee('marquee3', ['100% seguro y sin riesgo','Garantía de 30 días','Envío gratis 2-4 días','100% seguro y sin riesgo','Garantía de 30 días','Envío gratis 2-4 días']);

/* ---- Bundles ---- */
document.querySelectorAll('.nx-bundle').forEach(b=>{
  b.addEventListener('click',()=>{
    document.querySelectorAll('.nx-bundle').forEach(x=>x.classList.remove('sel'));
    b.classList.add('sel');
  });
});

/* ---- Galería ---- */
const galSlides = [(window.MUSA_ASSETS&&window.MUSA_ASSETS['ad-assets/producto.jpg']),(window.MUSA_ASSETS&&window.MUSA_ASSETS['ad-assets/gallery-2.jpg']),(window.MUSA_ASSETS&&window.MUSA_ASSETS['ad-assets/gallery-3.jpg']),(window.MUSA_ASSETS&&window.MUSA_ASSETS['ad-assets/gallery-4.jpg']),(window.MUSA_ASSETS&&window.MUSA_ASSETS['ad-assets/gallery-5.jpg'])];
let galIdx = 0;
function galSet(btn, src){
  const main = document.getElementById('galMain');
  if(main){ main.src = src; }
  galIdx = galSlides.indexOf(src);
  document.querySelectorAll('.nx-thumb').forEach(t=>t.classList.remove('active'));
  btn.classList.add('active');
}
function galMove(dir){
  galIdx = (galIdx + dir + galSlides.length) % galSlides.length;
  const thumbs = document.querySelectorAll('.nx-thumb');
  galSet(thumbs[galIdx], galSlides[galIdx]);
}


/* ============================================================
   Seleccion de bundle + trigger Releasit COD  (musa)
   Patron canonico (memory/project_bundles_as_variants):
   cada bundle = 1 variante real con precio POR UNIDAD; se manda la cantidad
   real en input[name="quantity"] (Releasit lo lee del DOM al disparar COD),
   asi precio_unitario x qty = total del bundle y el pedido lleva las unidades
   fisicas reales para Dropi.
   NO usar _rsiV2.setState como primer path: solo el click nativo del boton
   Releasit re-lee window.productData tras cambiar la variante.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) {
      i.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function bundleQty(el) {
    var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
    if (!q) {
      var idx = parseInt(el.getAttribute('data-bundle-index'), 10);
      q = isNaN(idx) ? 1 : idx + 1;
    }
    return q || 1;
  }

  // Los tiers llevan variant-id + qty; los CTA solo llaman a TriggerCOD(this),
  // asi el selector sirve igual si el tier es <div> o <button>.
  var bundles = document.querySelectorAll('[data-bundle-variant-id][data-bundle-qty]');

  function selectBundle(el) {
    var id = el.getAttribute('data-bundle-variant-id');
    if (!id) return;
    selectedVariantId = id;
    selectedQty = bundleQty(el);
    setVariantOnAllForms(id, selectedQty);
  }

  bundles.forEach(function (el) {
    el.addEventListener('click', function () { selectBundle(el); });
  });

  // Init: el bundle marcado activo en el HTML (o el primero)
  (function initSelected() {
    var active = null;
    for (var i = 0; i < bundles.length; i++) {
      var c = bundles[i].className || '';
      if (/(^|\s)(act|sel|activo|on|selected)(\s|$)/.test(c)) { active = bundles[i]; break; }
    }
    if (!active) active = bundles[0];
    if (!active) return;
    selectedVariantId = active.getAttribute('data-bundle-variant-id');
    selectedQty = bundleQty(active);
    setVariantOnAllForms(selectedVariantId, selectedQty);
  })();

  window.musaTriggerCOD = function (btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
